<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Meets/elements/Title.vue'

export default {
  name: 'MeetForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>
